import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  getNotificationsQuerySchema,
  NotificationStateWriteSchema,
  OKGeneric,
  PresentableNotificationSchema,
  ResponseMetaSchema,
} from '../models';

extendZodWithOpenApi(z);

const c = initContract();

export const apiNotifications = c.router({
  getNotifications: {
    method: 'GET',
    path: `/1.0/notifications`,
    description:
      'Get a list of notifications for the current user, optionally scoped to an account (with or without personal notifications included).',
    query: getNotificationsQuerySchema,
    responses: {
      200: z.object({
        notifications: z.array(PresentableNotificationSchema),
        meta: ResponseMetaSchema.pick({ count: true, totalCount: true }),
      }),
    },
    summary: 'Get a list of notifications for the current user',
  },
  batchSetNotificationsState: {
    method: 'PUT',
    path: `/1.0/notification_states/batch`,
    description: 'Batch update notification states, usually to mark as `read_at` or `discarded_at`',
    body: z.object({
      notification_states: z.array(NotificationStateWriteSchema),
    }),
    responses: {
      200: OKGeneric,
    },
    summary: 'Batch update notification states',
  },
});
